import { AmplitudeFlagKey, FormStatus, TicketingFormCategory } from "@simplyk/common";

import { trpc } from "@/common/helpers/trpc";
import { useAmplitudeFeatureFlag } from "@/common/hooks/amplitude/useAmplitudeFeatureFlag";
import { TicketingOutput } from "@/common/types/trpc";

export const useCampaignLifeCycleStep = (ticketing: TicketingOutput | null) => {
  const isMembershipDraft = Boolean(
    ticketing?.formCategory === TicketingFormCategory.MembershipV2 && ticketing.status === FormStatus.Draft
  );

  const { isActive: isCampaignReplacementActive, loading: isFlagLoading } = useAmplitudeFeatureFlag({
    flagKey: AmplitudeFlagKey.MembershipCampaignReplacement,
    organizationId: ticketing?.organizationId ?? undefined,
    skip: !isMembershipDraft,
  });
  const isEnabled = isMembershipDraft && isCampaignReplacementActive;

  const { data: replaceableCampaigns, isLoading: isReplaceableCampaignsLoading } =
    trpc.getReplaceableMembershipCampaigns.useQuery(
      { ticketingId: ticketing?.id ?? "" },
      { enabled: Boolean(isEnabled && ticketing?.id) }
    );

  const hasReplaceableCampaign = Boolean(
    replaceableCampaigns && (replaceableCampaigns.campaigns.length > 0 || replaceableCampaigns.replacesTicketingId)
  );

  return {
    isCampaignLifeCycleStepOn: isEnabled && hasReplaceableCampaign,
    isCampaignLifeCycleStepLoading:
      isMembershipDraft && (isFlagLoading || (isEnabled && isReplaceableCampaignsLoading)),
  };
};
